import { useState, useEffect } from 'react';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-form');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const handleNavClick = (href: string) => {
    setIsMobileMenuOpen(false);
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/1f6b76a1d4245ce85a9c4f8008ef48be.jpeg)'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
      </div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center space-x-2 cursor-pointer z-50">
            <img 
              src={isScrolled 
                ? "https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/826c552476badc913a23e7605116bff7.png"
                : "https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/5bc5af811e2f931fbde5d199712dd10f.png"
              }
              alt="MeVER Chair ロゴ" 
              title="MeVER Chair"
              className="h-7 sm:h-8 w-auto"
            />
          </a>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <a href="#products" onClick={(e) => { e.preventDefault(); handleNavClick('#products'); }} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-[#4a4a4a] hover:text-[#8E7CC3]' : 'text-white/90 hover:text-white'}`}>
              製品ラインナップ
            </a>
            <a href="/compare" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-[#4a4a4a] hover:text-[#8E7CC3]' : 'text-white/90 hover:text-white'}`}>
              製品比較
            </a>
            <a href="/compare#diagnosis" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-[#4a4a4a] hover:text-[#8E7CC3]' : 'text-white/90 hover:text-white'}`}>
              モデル診断
            </a>
            <a href="#case-studies" onClick={(e) => { e.preventDefault(); handleNavClick('#case-studies'); }} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-[#4a4a4a] hover:text-[#8E7CC3]' : 'text-white/90 hover:text-white'}`}>
              導入実績
            </a>
            <a href="#roi-simulator" onClick={(e) => { e.preventDefault(); handleNavClick('#roi-simulator'); }} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-[#4a4a4a] hover:text-[#8E7CC3]' : 'text-white/90 hover:text-white'}`}>
              投資対効果
            </a>
            <button
              onClick={scrollToContact}
              className="bg-[#8E7CC3] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#7A6AAF] transition-all whitespace-nowrap cursor-pointer shadow-lg"
            >
              お問い合わせ
            </button>
          </div>

          {/* Mobile Hamburger Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden z-50 w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="メニュー"
          >
            {isMobileMenuOpen ? (
              <i className={`ri-close-line text-2xl ${isScrolled ? 'text-[#1a1a2e]' : 'text-white'}`}></i>
            ) : (
              <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-[#1a1a2e]' : 'text-white'}`}></i>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`lg:hidden fixed inset-0 bg-white z-40 transition-transform duration-300 ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
          <div className="flex flex-col pt-20 px-6 space-y-6">
            <a href="#products" onClick={(e) => { e.preventDefault(); handleNavClick('#products'); }} className="text-base font-medium text-[#1a1a2e] hover:text-[#8E7CC3] transition-colors cursor-pointer py-3 border-b border-[#e8e6e3]">
              製品ラインナップ
            </a>
            <a href="/compare" onClick={() => setIsMobileMenuOpen(false)} className="text-base font-medium text-[#1a1a2e] hover:text-[#8E7CC3] transition-colors cursor-pointer py-3 border-b border-[#e8e6e3]">
              製品比較
            </a>
            <a href="/compare#diagnosis" onClick={() => setIsMobileMenuOpen(false)} className="text-base font-medium text-[#1a1a2e] hover:text-[#8E7CC3] transition-colors cursor-pointer py-3 border-b border-[#e8e6e3]">
              モデル診断
            </a>
            <a href="#case-studies" onClick={(e) => { e.preventDefault(); handleNavClick('#case-studies'); }} className="text-base font-medium text-[#1a1a2e] hover:text-[#8E7CC3] transition-colors cursor-pointer py-3 border-b border-[#e8e6e3]">
              導入実績
            </a>
            <a href="#roi-simulator" onClick={(e) => { e.preventDefault(); handleNavClick('#roi-simulator'); }} className="text-base font-medium text-[#1a1a2e] hover:text-[#8E7CC3] transition-colors cursor-pointer py-3 border-b border-[#e8e6e3]">
              投資対効果
            </a>
            <button
              onClick={scrollToContact}
              className="bg-[#8E7CC3] text-white px-6 py-3 rounded-full text-base font-medium hover:bg-[#7A6AAF] transition-all whitespace-nowrap cursor-pointer shadow-lg mt-4"
            >
              お問い合わせ
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 min-h-screen flex items-center justify-center">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 w-full text-center">
          {/* Authority Badges */}
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-8 sm:mb-10">
            <div className="bg-white/10 backdrop-blur-sm px-3 sm:px-4 py-1.5 sm:py-2 rounded-full flex items-center space-x-2 border border-white/10">
              <i className="ri-shield-check-line text-[#8E7CC3] text-sm sm:text-base"></i>
              <span className="text-xs font-medium tracking-wide text-white">BIFMA認証</span>
            </div>
            <div className="bg-white/10 backdrop-blur-sm px-3 sm:px-4 py-1.5 sm:py-2 rounded-full flex items-center space-x-2 border border-white/10">
              <i className="ri-time-line text-[#8E7CC3] text-sm sm:text-base"></i>
              <span className="text-xs font-medium tracking-wide text-white">5年保証</span>
            </div>
            <div className="bg-white/10 backdrop-blur-sm px-3 sm:px-4 py-1.5 sm:py-2 rounded-full flex items-center space-x-2 border border-white/10">
              <i className="ri-building-line text-[#8E7CC3] text-sm sm:text-base"></i>
              <span className="text-xs font-medium tracking-wide text-white">導入実績多数</span>
            </div>
          </div>

          {/* Main Catchcopy */}
          <div className="mb-6 sm:mb-8">
            <p className="text-base sm:text-lg font-light tracking-wider text-white/80 mb-3 sm:mb-4">
              オフィスチェアで、
            </p>
            <h1 className="text-3xl sm:text-5xl lg:text-7xl font-bold leading-tight tracking-tight text-white">
              座る時間を利益に変える。
            </h1>
          </div>

          {/* Sub Copy */}
          <div className="text-sm sm:text-base lg:text-lg leading-relaxed mb-8 sm:mb-12 text-white/90 max-w-2xl mx-auto" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            社員の集中力・創造性・回復力を引き出す。<br />
            シリコンバレー流の生産性思想から生まれた、<br />
            <span className="text-[#B8A9D9] font-medium">戦略投資としてのワークチェア。</span>
          </div>

          {/* CTA Buttons - Centered & Optimized */}
          <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 mb-8 sm:mb-10 px-4">
            <div className="relative">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#8E7CC3] text-white text-xs px-3 py-1 rounded-full font-medium shadow-md whitespace-nowrap">
                30秒で完了
              </div>
              <button
                onClick={scrollToContact}
                className="w-full sm:w-auto bg-white text-[#1a1a2e] px-8 sm:px-10 py-4 sm:py-5 rounded-full text-sm sm:text-base font-bold hover:bg-white/95 transition-all flex items-center justify-center space-x-2 sm:space-x-3 shadow-xl whitespace-nowrap cursor-pointer"
              >
                <span>法人特別価格・お見積り</span>
                <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
              </button>
            </div>
            <a
              href="#products"
              onClick={(e) => { e.preventDefault(); handleNavClick('#products'); }}
              className="w-full sm:w-auto border border-white/30 text-white px-8 sm:px-10 py-4 sm:py-5 rounded-full text-sm sm:text-base font-medium hover:bg-white/10 transition-all flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer"
            >
              <span>製品を見る</span>
            </a>
          </div>

          {/* Diagnosis CTA - Centered */}
          <a
            href="#diagnosis"
            onClick={(e) => { e.preventDefault(); handleNavClick('#diagnosis'); }}
            className="group inline-flex items-center gap-3 sm:gap-4 bg-[#1a1a2e]/60 backdrop-blur-md border border-white/10 rounded-xl px-4 sm:px-6 py-3 sm:py-4 hover:bg-[#1a1a2e]/80 transition-all cursor-pointer max-w-full"
          >
            <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-[#8E7CC3] flex items-center justify-center flex-shrink-0">
              <i className="ri-stethoscope-line text-base sm:text-lg text-white"></i>
            </div>
            <div className="text-left flex-1 min-w-0">
              <div className="text-xs sm:text-sm font-bold text-white flex items-center gap-2 flex-wrap">
                <span>どのモデルが最適？無料診断</span>
                <span className="text-xs bg-[#8E7CC3]/30 text-[#B8A9D9] px-2 py-0.5 rounded-full font-medium">約1分</span>
              </div>
              <div className="text-xs text-white/60 mt-0.5 hidden sm:block">4つの質問でCore・Pro・Styleから最適モデルをご提案</div>
            </div>
            <i className="ri-arrow-right-s-line text-lg sm:text-xl text-white/40 group-hover:text-white group-hover:translate-x-1 transition-all flex-shrink-0"></i>
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 hidden sm:flex">
        <div className="flex flex-col items-center gap-2 text-white/50">
          <span className="text-xs tracking-widest">SCROLL</span>
          <div className="w-px h-8 bg-gradient-to-b from-white/50 to-transparent"></div>
        </div>
      </div>
    </div>
  );
}
